/* eslint-disable */
import { createReducer, createActions } from "reduxsauce"
import Immutable from "seamless-immutable"

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  searchRequest: ["search"],
  searchUpdate: ["changes"],
})

export const AppleMusicTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  phase: null,
  token: null,
  expires: null,
  search: '',
  data: [],
  updated: null,
  error: null,
  haveCalledBefore: false,
})

/* ------------- Reducers ------------- */

export const searchRequest = (state, action) => {
  console.tron.display({ name: 'searchRequest', preview: 'details', value: { state, action } })
  const { search } = action
  return state.merge({ phase: 'loading', search, error: null })
}

export const searchUpdate = (state, action) => {
  console.tron.display({ name: 'searchUpdate', preview: 'details', value: { action } })
  const { changes } = action
  return state.merge(changes)
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SEARCH_REQUEST]: searchRequest,
  [Types.SEARCH_UPDATE]: searchUpdate,
})
